import { classValidatorResolver } from '@hookform/resolvers/class-validator';
import { useForm, UseFormProps } from 'react-hook-form';
import { useCustomRegister } from '../../../hooks';
import { DiscountsFormDto } from '../../../models/dto';

const resolver = classValidatorResolver(DiscountsFormDto);

export const useDiscountsModalState = <TValues extends DiscountsFormDto, Context = any>(
	props: UseFormProps<TValues, Context>
) => {
	const form = useForm<TValues>({
		...props,
		resolver,
	});

	const formState = form.watch();

	const { register } = useCustomRegister(form);

	return {
		form,
		formData: formState,
		register,
		errors: form.formState.errors,
	};
};
